<template>
  <div class="flex h-screen w-screen flex-col lg:flex-row">
    <NavBar
      :login="handleLogin"
      :header-service="headerService"
      :nav-module-type="NAV_MENU_TYPE.HOME"
      @handle-upgrade="togglePricingSection"
    >
      <template #pricingDialog>
        <Transition name="fade">
          <PricePlanDialog
            v-if="ifPricingSectionShown"
            trigger-source="side_nav"
            @close-dialog="togglePricingSection"
          ></PricePlanDialog>
        </Transition>
      </template>
    </NavBar>
    <RouterView></RouterView>
  </div>
</template>
<script setup lang="ts">
import { useHeaderService } from '@/composables/use-header-service';
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { ref } from 'vue';
import PricePlanDialog from '@/components/common/dialogs/PricePlanDialog.vue';
import { useLoginSdk } from './composables/use-loginsdk';
import { i18n } from '@/infrastructure/locales';
import { useTracking } from './composables/tracking/use-tracking';
import { useMseProducts } from './composables/home/use-product';

const { headerService } = useHeaderService();
const { openLoginDialog } = useLoginSdk(i18n as any);
const { sendTracking } = useTracking();
const { usedProduct } = useMseProducts();

const ifPricingSectionShown = ref(false);

const togglePricingSection = () => {
  ifPricingSectionShown.value = !ifPricingSectionShown.value;
};

const handleLogin = () => {
  sendTracking('ss_plg_register', 'register_exposure', {
    registrationSource: `mse_${usedProduct.value.toLowerCase()}`,
  });
  openLoginDialog(false, false, () => {
    sendTracking('ss_plg_register', 'register_close', {
      registrationSource: `mse_${usedProduct.value.toLowerCase()}`,
    });
  });
};
</script>
